
import { Component, MixedVue } from "@/vue";

@Component({
  name: "SuspendedStep",
})
export default class SuspendedStep extends MixedVue {}
